import React from 'react';

const CLIMATE_VARIABLES = [
  { id: 'ghi', label: 'GHI (Global Horizontal Irradiance)', unit: 'W/m\u00B2', category: 'Solar' },
  { id: 'dni', label: 'DNI (Direct Normal Irradiance)', unit: 'W/m\u00B2', category: 'Solar' },
  { id: 'dhi', label: 'DHI (Diffuse Horizontal Irradiance)', unit: 'W/m\u00B2', category: 'Solar' },
  { id: 'temperature', label: 'Temperature (2m)', unit: '\u00B0C', category: 'Meteorological' },
  { id: 'wind_speed', label: 'Wind Speed (10m)', unit: 'm/s', category: 'Meteorological' },
  { id: 'humidity', label: 'Relative Humidity (2m)', unit: '%', category: 'Meteorological' },
  { id: 'pressure', label: 'Surface Pressure', unit: 'hPa', category: 'Meteorological' },
  { id: 'precipitation', label: 'Precipitation', unit: 'mm', category: 'Meteorological' },
];

const styles = {
  container: { marginTop: 8 },
  sectionTitle: {
    fontSize: 11, fontWeight: 700, color: '#94a3b8', textTransform: 'uppercase',
    letterSpacing: '0.5px', marginBottom: 6, marginTop: 12,
  },
  row: {
    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
    padding: '5px 8px', borderRadius: 4, marginBottom: 2,
    background: '#0f172a',
  },
  varInfo: { display: 'flex', alignItems: 'center', gap: 8, flex: 1 },
  varLabel: { fontSize: 12, color: '#e2e8f0' },
  varUnit: { fontSize: 11, color: '#64748b' },
  selectWrap: { display: 'flex', alignItems: 'center', gap: 6 },
  select: {
    background: '#1e293b', border: '1px solid #334155', borderRadius: 4, color: '#e2e8f0',
    padding: '4px 8px', fontSize: 12, minWidth: 180, cursor: 'pointer',
  },
  dot: { width: 8, height: 8, borderRadius: '50%', flexShrink: 0 },
};

const VariableAssignmentTable = ({ sources, assignments, onAssign }) => {
  let lastCategory = null;

  return (
    <div style={styles.container}>
      {CLIMATE_VARIABLES.map(v => {
        const assigned = assignments[v.id];
        const showHeader = v.category !== lastCategory;
        lastCategory = v.category;

        return (
          <React.Fragment key={v.id}>
            {showHeader && (
              <div style={styles.sectionTitle}>{v.category}</div>
            )}
            <div style={styles.row}>
              <div style={styles.varInfo}>
                <span style={styles.varLabel}>{v.label}</span>
                <span style={styles.varUnit}>{v.unit}</span>
              </div>
              <div style={styles.selectWrap}>
                <select
                  style={styles.select}
                  value={assigned || ''}
                  onChange={(e) => onAssign(v.id, e.target.value || null)}
                >
                  <option value="">-- not included --</option>
                  {sources.map(src => {
                    const hasVar = (src.variables || []).includes(v.id);
                    return (
                      <option key={src.id} value={src.id} disabled={!hasVar}>
                        {src.name} ({src.distance_km} km){!hasVar ? ' [N/A]' : ''}
                      </option>
                    );
                  })}
                </select>
                {assigned && (
                  <span style={{ ...styles.dot, background: sources.find(s => s.id === assigned)?.color || '#666' }} />
                )}
              </div>
            </div>
          </React.Fragment>
        );
      })}
    </div>
  );
};

export { CLIMATE_VARIABLES };
export default VariableAssignmentTable;
